<template>
  <div>
    <div class="field_left">
      <text-input id="rolegroupname"
                  :required="true"
                  v-model="entity.name"
                  :disabled="!isEditable"
                  ref="nameref"
      >
        <translate class="translate">Název</translate>

      </text-input>
    </div>
    <div class="field_right">
      <text-input id="rolegroupcode"
                  :required="true"
                  :disabled="!isEditable"
                  v-model="entity.code"
                  ref="coderef"
      >
        <translate class="translate">Kód</translate>
      </text-input>
    </div>
  </div>
</template>

<script>
export default {
  name: "RoleGroupsBasicForm",
  props: {
    isEditable: Boolean,
    entity: Object,
  }
};
</script>



// WEBPACK FOOTER //
// src/components/views/roleGroups/forms/RoleGroupsBasicForm.vue